import Vue from "vue";
import VueCookies from "vue-cookies";
import axios from "axios";
import { ehErroVersaoInvalida, forcarAtualizacaoComVersao, forcarRecarregamentoFresco, obterVersaoServidor, salvarVersaoAtual } from "@/utils/versao";

Vue.use(VueCookies);

salvarVersaoAtual(process.env.VUE_APP_VERSAO);

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_URL_WEB_API,
  timeout: 600000 //10 minutos - para evitar que o navegador refaça a requisição ou caia por timeout
});

let tratandoVersaoInvalida = false;

axiosInstance.interceptors.request.use(
  function (config) {
    const token = `Bearer ${VueCookies.get("token")}`;
    if (token) {
      config.headers.Authorization = token;
      config.headers.Versao = process.env.VUE_APP_VERSAO;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (!tratandoVersaoInvalida && ehErroVersaoInvalida(error)) {
      tratandoVersaoInvalida = true;
      error.__versaoTratada = true;

      const versaoServidor = obterVersaoServidor(error);
      if (versaoServidor) {
        salvarVersaoAtual(versaoServidor);
        setTimeout(() => forcarAtualizacaoComVersao(versaoServidor), 0);
      } else {
        setTimeout(() => forcarRecarregamentoFresco(), 0);
      }

      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

async function normalizaErroBlob(error) {
  if (!error || !error.response || !error.response.data) {
    return error;
  }

  const contentType = error.response.headers ? error.response.headers["content-type"] || "" : "";
  const isBlob = typeof Blob !== "undefined" && error.response.data instanceof Blob;
  if (!isBlob) {
    return error;
  }

  try {
    const textoErro = await error.response.data.text();
    if (contentType.includes("application/json")) {
      error.response.data = JSON.parse(textoErro);
    } else {
      error.response.data = textoErro;
    }
  } catch {
    // Mantém o erro original caso não consiga converter o blob
  }

  return error;
}

export const api = {
  versaoAtual: salvarVersaoAtual(process.env.VUE_APP_VERSAO),
  get(endpoint, config = {}) {
    return axiosInstance.get(endpoint, {
      headers: { "Access-Control-Allow-Origin": "*" },
      ...config
    });
  },
  async openPdf(caminho) {
    try {
      const response = await axiosInstance.get("fin/arquivo/pdf", {
        params: { caminho },
        responseType: "blob"
      });

      const blobUrl = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
      window.open(blobUrl, "_blank");
      setTimeout(() => window.URL.revokeObjectURL(blobUrl), 60000);
    } catch (error) {
      throw await normalizaErroBlob(error);
    }
  },
  post(endpoint, body) {
    return axiosInstance.post(endpoint, body);
  },
  put(endpoint, body) {
    return axiosInstance.put(endpoint, body);
  },
  delete(endpoint) {
    return axiosInstance.delete(endpoint);
  },
  loginAuth(body) {
    return axios.post(process.env.VUE_APP_URL_WEB_API + "login/auth-token", body);
  },
  login(body) {
    return axios.post(process.env.VUE_APP_URL_WEB_API + "login/access-token", body);
  }
};
